import * as React from 'react';

import Authorization from '../../../../stores/Authorization';
import { IOrganizationRoleModel } from '../../../../interfaces/IUser';
import { useAuthContext } from '../../../../contexts/AuthContext';
import { useZoneContext } from '../../../../contexts/useZoneContext';

export interface IZoneSwitchMenuItemProps {
    onZoneChange: (org: IOrganizationRoleModel, redirectPath?: string) => void;
    hideSelectedZoneName?: boolean;
}

export function ZoneSwitchMenuItem(props: IZoneSwitchMenuItemProps) {
    const { user, isLoggedIn } = useAuthContext();
    const { zoneName } = useZoneContext();

    if (!Authorization.allowOrganizationSwitch(user)) {
        return null;
    }

    return (
        <div className="zoneContainer">
            <button id="btn-zone" className=" btn-zone-select font-green" data-bs-toggle="dropdown">
                <span style={{ whiteSpace: 'nowrap' }}>
                    ZONE{' '}
                    {!props.hideSelectedZoneName && (
                        <span className="horizontal-margin-lg font-green">
                            {zoneName}
                        </span>
                    )}
                </span>
            </button>
            <div className="dropdown-menu no-margin-top">
                {isLoggedIn && (
                    <div>
                        {user?.organizationRoles?.map((org: IOrganizationRoleModel) => {
                            return (
                                <a
                                    key={org.guid}
                                    onClick={() => props.onZoneChange(org)}
                                    className="dropdown-item"
                                    style={{
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                    }}
                                >
                                    {org.shortName} ({org.displayName})
                                </a>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
}
